// Utilities
import { Colors } from "../../themes/themes";

interface ILogo {
  className?: string;
}

export const Logo = ({ className }: ILogo) => {
  return (
    <svg
      className={className}
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4_152)">
        <path
          d="M38.25 0.796875H12.75C11.8699 0.796875 11.1562 1.51048 11.1562 2.39062V20.9312C11.1562 28.3012 16.7454 34.3849 23.9062 35.181V41.4375C23.9062 42.3176 24.6199 43.0312 25.5 43.0312C26.3801 43.0312 27.0938 42.3176 27.0938 41.4375V35.181C34.2546 34.3849 39.8438 28.3012 39.8438 20.9312V2.39062C39.8438 1.51048 39.1301 0.796875 38.25 0.796875ZM36.6562 20.9312C36.6562 26.8418 32.0328 31.68 26.2143 32.0513C25.9986 31.9422 25.7582 31.875 25.5 31.875C25.2418 31.875 25.0014 31.9422 24.7857 32.0513C18.9672 31.68 14.3438 26.8418 14.3438 20.9312V3.98438H36.6562V20.9312Z"
          fill={Colors.green100}
        />
        <path
          d="M31.875 39.8438H31.0781C30.198 39.8438 29.4844 40.5574 29.4844 41.4375C29.4844 42.3176 30.198 43.0312 31.0781 43.0312H31.875C33.1933 43.0312 34.2656 44.1036 34.2656 45.4219V47.0156H16.7344V45.4219C16.7344 44.1036 17.8067 43.0312 19.125 43.0312H19.9219C20.802 43.0312 21.5156 42.3176 21.5156 41.4375C21.5156 40.5574 20.802 39.8438 19.9219 39.8438H19.125C16.0496 39.8438 13.5469 42.346 13.5469 45.4219V48.6094C13.5469 49.4895 14.2605 50.2031 15.1406 50.2031H35.8594C36.7395 50.2031 37.4531 49.4895 37.4531 48.6094V45.4219C37.4531 42.346 34.9504 39.8438 31.875 39.8438Z"
          fill={Colors.green100}
        />
        <path
          d="M25.5 23.9062C29.0151 23.9062 31.875 21.0464 31.875 17.5312C31.875 14.0161 29.0151 11.1562 25.5 11.1562C24.6199 11.1562 23.9062 11.8699 23.9062 12.75C23.9062 13.6301 24.6199 14.3438 25.5 14.3438C27.2579 14.3438 28.6875 15.7737 28.6875 17.5312C28.6875 19.2888 27.2579 20.7188 25.5 20.7188C23.7421 20.7188 22.3125 19.2888 22.3125 17.5312C22.3125 17.3519 22.3273 17.1725 22.3569 16.9986C22.5024 16.1305 21.9172 15.3087 21.0495 15.1628C20.1763 15.0122 19.3592 15.6025 19.2129 16.4702C19.1546 16.818 19.125 17.1752 19.125 17.5312C19.125 21.0464 21.9849 23.9062 25.5 23.9062Z"
          fill={Colors.green100}
        />
        <path
          d="M46.2188 5.57812H43.8281C42.948 5.57812 42.2344 6.29173 42.2344 7.17188C42.2344 8.05202 42.948 8.76562 43.8281 8.76562H46.2188C46.6584 8.76562 47.0156 9.12321 47.0156 9.5625V23.1094C47.0156 25.3062 45.2281 27.0938 43.0312 27.0938H42.2344C41.3542 27.0938 40.6406 27.8074 40.6406 28.6875C40.6406 29.5676 41.3542 30.2812 42.2344 30.2812H43.0312C46.9861 30.2812 50.2031 27.0638 50.2031 23.1094V9.5625C50.2031 7.36565 48.4156 5.57812 46.2188 5.57812Z"
          fill={Colors.green100}
        />
        <path
          d="M8.76562 27.0938H7.96875C5.7719 27.0938 3.98438 25.3062 3.98438 23.1094V9.5625C3.98438 9.12321 4.34157 8.76562 4.78125 8.76562H7.17188C8.05202 8.76562 8.76562 8.05202 8.76562 7.17188C8.76562 6.29173 8.05202 5.57812 7.17188 5.57812H4.78125C2.5844 5.57812 0.796875 7.36565 0.796875 9.5625V23.1094C0.796875 27.0638 4.01395 30.2812 7.96875 30.2812H8.76562C9.64577 30.2812 10.3594 29.5676 10.3594 28.6875C10.3594 27.8074 9.64577 27.0938 8.76562 27.0938Z"
          fill={Colors.green100}
        />
      </g>
      <defs>
        <clipPath id="clip0_4_152">
          <rect width="51" height="51" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
